import React, { useContext, useMemo } from 'react';
import * as Styled from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { getScarvesData } from '@containers/home/body/selectors';
import Flag from '@components/flag';
import {
    setDetailedInfo,
    setTopScroll,
} from '@containers/home/body/actions';
import { ThemeContext } from '@src/index';
import SportsImage from '../../../assets/sports.png';
import UltrasImage from '../../../assets/ultras.png';
import PlayerImage from '../../../assets/player.png';

const Body = () => {
    const dispatch = useDispatch();
    const palette = useContext(ThemeContext);
    const { PRIMARY_FONT_COLOR } = palette;

    const categoriesArray = useSelector(getScarvesData);

    const { countries, other } = useMemo(() => {
        const lastCount = 4;
        return {
            countries: categoriesArray.slice(0, -lastCount),
            other: categoriesArray.slice(-lastCount),
        };
    }, [categoriesArray]);

    const countriesCategories = useMemo(
        () =>
            countries.map(singleCategory => (
                <Styled.HomeCardWrapper
                    key={singleCategory.iso3}
                >
                    <Styled.HomeCardLink
                        to={`/${singleCategory.slug}`}
                        onClick={() => {
                            const topScroll =
                                window.scrollY;

                            setTopScroll(
                                dispatch,
                                topScroll
                            );
                            setDetailedInfo(
                                dispatch,
                                singleCategory
                            );
                        }}
                        color={PRIMARY_FONT_COLOR}
                    >
                        <Flag
                            iso3={singleCategory.iso3}
                            size={140}
                        />
                        <Styled.HomeCardTitle>
                            {`${singleCategory.categoryName} (${singleCategory.scarves.length})`}
                        </Styled.HomeCardTitle>
                    </Styled.HomeCardLink>
                </Styled.HomeCardWrapper>
            )),
        [countries, dispatch, PRIMARY_FONT_COLOR]
    );

    const otherCategories = useMemo(
        () =>
            other.map(singleCategory => (
                <Styled.HomeCardWrapper
                    key={singleCategory.iso3}
                >
                    <Styled.HomeCardLink
                        to={`/${singleCategory.slug}`}
                        onClick={() => {
                            const topScroll =
                                window.scrollY;

                            setTopScroll(
                                dispatch,
                                topScroll
                            );
                            setDetailedInfo(
                                dispatch,
                                singleCategory
                            );
                        }}
                        color={PRIMARY_FONT_COLOR}
                    >
                        {singleCategory.iso3 ===
                        'OTHR' ? (
                            <img
                                src={SportsImage}
                                alt="Other"
                                width={140}
                                height={140}
                            />
                        ) : singleCategory.iso3 ===
                          'ULTR' ? (
                            <img
                                src={UltrasImage}
                                alt="Ultras"
                                width={140}
                                height={140}
                            />
                        ) : singleCategory.iso3 ===
                          'PLYR' ? (
                            <img
                                src={PlayerImage}
                                alt="Player"
                                width={140}
                                height={140}
                            />
                        ) : (
                            <Flag
                                iso3={
                                    singleCategory.iso3
                                }
                                size={140}
                            />
                        )}
                        <Styled.HomeCardTitle>
                            {`${singleCategory.categoryName} (${singleCategory.scarves.length})`}
                        </Styled.HomeCardTitle>
                    </Styled.HomeCardLink>
                </Styled.HomeCardWrapper>
            )),
        [other, dispatch, PRIMARY_FONT_COLOR]
    );

    return (
        <Styled.HomeBody>
            <Styled.HomeCategories>
                {countriesCategories}
            </Styled.HomeCategories>
            <Styled.SectionSeparator
                $CARD_BORDER_COLOR={
                    palette.CARD_BORDER_COLOR
                }
                $isDarkMode={palette.isDarkMode}
            />
            <Styled.HomeCategories>
                {otherCategories}
            </Styled.HomeCategories>
        </Styled.HomeBody>
    );
};

export default Body;
